import { NgModule } from "@angular/core";
import { SharedModule } from "src/app/shared/shared.module";
import { VenuesModule } from "../venues/venues.module";
import { ItemRequestWizardCategoryComponent } from "./components/item-request-wizard-category/item-request-wizard-category.component";
import { ItemRequestWizardDialogComponent } from "./components/item-request-wizard-dialog/item-request-wizard-dialog.component";
import { ItemRequestWizardHowItWorksComponent } from "./components/item-request-wizard-how-it-works/item-request-wizard-how-it-works.component";
import { ItemRequestWizardImageSkuRequestComponent } from "./components/item-request-wizard-image-sku-request/item-request-wizard-image-sku-request.component";
import { ItemRequestWizardImageComponent } from "./components/item-request-wizard-image/item-request-wizard-image.component";
import { ItemRequestWizardPostSubmitDialogComponent } from "./components/item-request-wizard-post-submit-dialog/item-request-wizard-post-submit-dialog.component";
import { ItemRequestWizardSkuRequestPriceComponent } from "./components/item-request-wizard-sku-request-price/item-request-wizard-sku-request-price.component";
import { ItemRequestWizardSpecsComponent } from "./components/item-request-wizard-specs/item-request-wizard-specs.component";
import { ItemRequestWizardComponent } from "./components/item-request-wizard/item-request-wizard.component";
import { VenueRequestWizardDialogComponent } from "./components/venue-request-wizard-dialog/venue-request-wizard-dialog.component";
import { VenueRequestWizardHowItWorksComponent } from "./components/venue-request-wizard-how-it-works/venue-request-wizard-how-it-works.component";
import { VenueRequestWizardLinkComponent } from "./components/venue-request-wizard-link/venue-request-wizard-link.component";
import { VenueRequestWizardPaymentComponent } from "./components/venue-request-wizard-payment/venue-request-wizard-payment.component";
import { VenueRequestWizardPostSubmitDialogComponent } from "./components/venue-request-wizard-post-submit-dialog/venue-request-wizard-post-submit-dialog.component";
import { VenueRequestWizardPriceComponent } from "./components/venue-request-wizard-price/venue-request-wizard-price.component";
import { VenueRequestWizardRoomsComponent } from "./components/venue-request-wizard-rooms/venue-request-wizard-rooms.component";
import { VenueRequestWizardVenueDetailsComponent } from "./components/venue-request-wizard-venue-details/venue-request-wizard-venue-details.component";
import { VenueRequestWizardVenueSearchComponent } from "./components/venue-request-wizard-venue-search/venue-request-wizard-venue-search.component";
import { VenueRequestWizardComponent } from "./components/venue-request-wizard/venue-request-wizard.component";
import { ItemRequestWizardSkuRequestMoreInfoComponent } from './components/item-request-wizard-sku-request-more-info/item-request-wizard-sku-request-more-info.component';
import { ItemRequestWizardSkuRequestPaymentComponent } from './components/item-request-wizard-sku-request-payment/item-request-wizard-sku-request-payment.component';

@NgModule({
  declarations: [
    VenueRequestWizardLinkComponent,
    VenueRequestWizardHowItWorksComponent,
    VenueRequestWizardComponent,
    VenueRequestWizardVenueDetailsComponent,
    VenueRequestWizardRoomsComponent,
    VenueRequestWizardDialogComponent,
    ItemRequestWizardComponent,
    ItemRequestWizardHowItWorksComponent,
    ItemRequestWizardCategoryComponent,
    ItemRequestWizardSpecsComponent,
    ItemRequestWizardImageComponent,
    ItemRequestWizardImageSkuRequestComponent,
    ItemRequestWizardSkuRequestPriceComponent,
    ItemRequestWizardDialogComponent,
    VenueRequestWizardPostSubmitDialogComponent,
    ItemRequestWizardPostSubmitDialogComponent,
    VenueRequestWizardPaymentComponent,
    VenueRequestWizardPriceComponent,
    VenueRequestWizardVenueSearchComponent,
    ItemRequestWizardSkuRequestMoreInfoComponent,
    ItemRequestWizardSkuRequestPaymentComponent,
  ],
  imports: [SharedModule, VenuesModule],
  exports: [VenueRequestWizardLinkComponent, VenueRequestWizardComponent],
})
export class CustomerRequestsModule {}
